

import AlternativeInsulinReasons from "../alternativeInsulinReasons";
import MedCheckboxList from "../medCheckBoxList";
import PatientConditions from "../patientConditions";
import DateField from "../dateField";
import { FC, useState } from "react";
import { CurrentAndPriorTreatmentProps } from "./types";


const CurrentAndPriorTreatment: FC<CurrentAndPriorTreatmentProps> = ({ control, watch, setValue,getValues, resetField }): JSX.Element => {  
  const [selectedMeds, setSelectedMeds] = useState({});

  // const meds = ["Novolog", "Novolin", "Humalog", "Humulin", "Fiasp", "Lyumjev", "Aspart", "Lispro", "Apidra", "Admelog", "U200", "U500", "Two Orals Anti-diabetics"];
  const meds = ["Other", "Novolog", "Humulin", "Fiasp", "Aspart", "Lispro", "Apidra", "Two Orals Anti-diabetics"];

  const handleCheckboxChange = (name:any, checked:any) => {
    setSelectedMeds((prev) => ({ ...prev, [name]: checked }));
  };


  return (
    <>
      <MedCheckboxList
        meds={meds}
        selectedMeds={selectedMeds}
        onChange={handleCheckboxChange} 
        control={control} 
        watch={watch} 
        setValue={setValue} 
        getValues={getValues} 
        resetField={resetField}
      />

      <AlternativeInsulinReasons control={control} watch={watch} setValue={setValue} getValues={getValues} resetField={resetField}/>

      <PatientConditions control={control} watch={watch} setValue={setValue} getValues={getValues} resetField={resetField} />

      
    </>
  );
};
export default CurrentAndPriorTreatment;